export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const MESSAGE_TYPES = {
    EJECT: "ejectUser",
    MUTE: "muteUser",
    UNMUTE: "unMuteUser",
    TOGGLE_MUTE: "toggleMute",
    RECORDING_STARTED: "startRecording",
    RECORDING_STOPPED: "stopRecording",
    TERMINATE_ROOM: "terminateRoom",
    PROMOTE_USER: "promoteUser",
}

